export const SELECTION_TOOL_FILL_COLOR = 'rgba(0, 102, 255, 0.1)' as const;
export const SELECTION_TOOL_STROKE_COLOR = '#0066ff' as const;
export const NUMBERING_TOOL_STROKE_COLOR = '#00ff00' as const;
export const SELECTION_STROKE_COLOR = '#0D99FF';

export const DEFAULT_NODE_LABEL_ALIGNMENT = 'center' as const;
export const DEFAULT_FONT_FAMILY = 'Quicksand' as const;

export const DEFAULT_NODE_CIRCLE_RADIUS = 28;
export const DEFAULT_NODE_CIRCLE_STROKE_WIDTH = 8;
/** Dash segments for walk-up spot circles (Konva dash / SVG stroke-dasharray) */
export const SPOT_WALK_UP_DASH = [6, 6];

export const DEFAULT_NODE_RECT_COLOR = '#E8ECEF';
export const DEFAULT_NODE_TEXT_COLOR = '#6B6B6B';

export const DEFAULT_TEXT_SHAPE_COLOR = '#6B6B6B';
export const DEFAULT_TEXT_SHAPE_FONT_SIZE = 16;

export const DEFAULT_FURNITURE_FILL_COLOR = '#E8ECEF';
export const DEFAULT_FURNITURE_TEXT_COLOR = '#6B6B6B';

export const DEFAULT_ICON_FILL_COLOR = '#D1D5D9';
export const DEFAULT_ICON_TEXT_COLOR = '#6B6B6B';

// State icons (SpotStateIcons) can't reuse the dot's own fill as their
// default paint color — some availability states (e.g. occupied/unavailable)
// pair a near-white dot fill with a colored stroke for contrast, a ring the
// icon doesn't have. A fixed, always-legible neutral avoids that.
export const DEFAULT_STATE_ICON_COLOR = '#374151';

// Opaque — zone transparency is owned by fillOpacity, never baked into
// the color (the old '#3B82F620' default multiplied with fillOpacity
// into near-invisibility).
export const DEFAULT_ZONE_FILL_COLOR = '#3B82F6';
export const DEFAULT_ZONE_BORDER_COLOR = '#3B82F6';
export const DEFAULT_ZONE_BORDER_WIDTH = 2;
export const DEFAULT_ZONE_FILL_OPACITY = 0.12;
/** Fill opacity of a zone painted by a heatmap colour (`zoneColors`). */
export const HEAT_ZONE_FILL_OPACITY = 0.7;

export const DEFAULT_WALL_COLOR = '#D1D5D9';
export const DEFAULT_WALL_THICKNESS = 16;
// Thinner than a regular wall so the grid tool's auto-generated lines read
// as painted lines (e.g. a parking lot) rather than physical walls.
export const GRID_LINE_THICKNESS = 3;
// Spots always render above the "shapes" layer these lines live in (the
// editor's layer order is fixed: shapes, then spots), so a semi-transparent
// spot fill in the default pale wall gray blends into near-invisibility.
// A darker, more saturated color stays legible through that fill.
export const GRID_LINE_COLOR = '#374151';
export const DEFAULT_DOOR_COLOR = '#E8ECEF';
export const DEFAULT_DOOR_WIDTH = 60;
export const DEFAULT_WINDOW_WIDTH = 200;

export const EDITING_ZONE_MAX_WIDTH = 15000;
export const EDITING_ZONE_MAX_HEIGHT = 15000;
